import { render, staticRenderFns } from "./SAIFHeader.vue?vue&type=template&id=004e14e1"
import script from "./SAIFHeader.vue?vue&type=script&lang=js"
export * from "./SAIFHeader.vue?vue&type=script&lang=js"
import style0 from "./SAIFHeader.vue?vue&type=style&index=0&id=004e14e1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports